import global from "./global.js";
import Style from "./utils/Style.js";
import UsersDebug from "./users/UsersDebug.js";
import {json_apply_modifications} from "@/prototype/utils/JSON.js";
import StateMachine from "statemachine";
import {get_translation} from "svg-utils";

const d3 = global.d3;

const log = global.log.getLogger("f_mtac.users");
log.setLevel(log.levels.WARN);

const CAP_GEO = 1 << 0,
    CAP_GEO_POS = 1 << 1;

const MIN_DISTANCE_METERS = 10;

/**
 * @brief Handle the HTML node of a user in the User list
 * @param {*} login
 * @param {*} name
 * @param {*} capabilities
 * @param {*} style
 */
const User = function (login, name, capabilities, style) {
    const display_capabilities = () => {
        if (capabilities & CAP_GEO && capabilities & CAP_GEO_POS) {
            style.rule_set(login, `g.resource[data-user="${login}"] circle.user_name { fill: #0f0; }`);
        } else {
            style.rule_set(login, `g.resource[data-user="${login}"] circle.user_name { fill: #f00; }`);
        }
    };
    display_capabilities();

    const update_name_in_select_list = () => $(`#select-user option[value="${login}"]`)?.text(name);

    Object.defineProperty(this, "name", {
        set: (new_name) => {
            name = new_name;
            update_name_in_select_list();
        },
        get: () => name
    });

    Object.defineProperty(this, "capabilities", {
        set: (new_capabilities) => {
            capabilities = new_capabilities;
            display_capabilities();
        },
        get: () => capabilities
    });

    Object.defineProperty(this, "login", {
        set: () => {},
        get: () => login
    });

    this.remove = () => {
        log.debug(`User.remove login = ${login}`);
        $(`#select-user option[value="${login}"]`).remove();
        style.rule_unset(login);
    };

    this.refresh_capabilities = () => {
        log.debug("refresh_capabilities ", capabilities);
        display_capabilities();
    };
};

const UsersList = function () {
    var map = {};
    /*Object.defineProperty(this, "map", {
        set: () => {},
        get: () => map
    });*/

    this.get = (login) => {
        log.debug(`UsersList.get login = ${login}`);
        if (!(login in map)) {
            return null;
        }
        return map[login];
    };

    this.unset = (login) => {
        log.debug(`UsersList.unset login = ${login}`);
        var user = this.get(login);
        if (user === null) {
            return;
        }
        delete map[login];
        user.remove();
    };

    this.unset_all = () => {
        log.debug("UsersList.unset_all");
        $("#select-user").empty();
        map = {};
    };

    this.set = (login, name, capabilities, style) => {
        log.debug(`UsersList.set login = ${login}, name = ${name}`);
        var user = this.get(login);
        if (user !== null) {
            user.name = name;
            user.capabilities = capabilities;
            return;
        }
        user = new User(login, name, capabilities, style);
        map[login] = user;
        // Add the user into the select of user_list_area
        const opt = document.createElement("option");
        opt.value = login;
        opt.innerHTML = name;
        document.getElementById("select-user")?.appendChild(opt);
    };
};

const Users = function () {
    var users = new UsersList();
    var style = new Style();
    var space = null;
    style.rule_set_top("default", "g.resource circle.user_name { fill: #f00; }");

    Object.defineProperty(this, "space", {
        set: () => {},
        get: () => space
    });

    Object.defineProperty(this, "userlist", {
        set: () => {},
        get: () => users
    });

    const user_update = (login, name, capabilities) => {
        log.debug(`Users.user_update login = ${login}, name = ${name}`);
        var user = users.get(login);
        if (user !== null) {
            log.debug("Users.user_update login found, update user");
            user.name = name;
            user.capabilities = capabilities;
            return;
        }
        log.debug("Users.user_update login not found, add user");
        users.set(login, name, capabilities, style);
    };
    this.user_update = user_update;

    const self_update = () => {
        let {login, name, capabilities} = global.server.registrar.user;
        log.debug(`Users.self_update login = ${login}`);
        if (login === undefined) {
            return;
        }
        user_update(login, name, capabilities);
    };

    const user_remove = (login) => {
        log.debug(`Users.user_remove login = ${login}`);
        users.unset(login);
    };

    this.sync = async () => {
        log.debug("Users.sync in");
        if (space === null || space.room === null) {
            self_update();
            log.debug("Users.sync out");
            return;
        }
        try {
            log.debug("Users.sync before mtac_room_users");
            let response = await global.server.mtac_room_users(space.room);
            var users_list = response.data.list;
            log.debug("Users.sync users_list", users_list);
        } catch (error) {
            log.error("Users error while fetching user list", error);
            self_update();
            return;
        }
        var local_logins = [...document.querySelectorAll("#select-user option")].map((user) => user.value);
        log.debug("Users.sync local_logins", local_logins);
        for (let login in users_list) {
            let {name, capabilities} = users_list[login];
            user_update(login, name, capabilities);
            let login_index = local_logins.indexOf(login);
            if (login_index !== -1) {
                local_logins.splice(login_index, 1);
            }
        }
        for (let login of local_logins) {
            user_remove(login);
        }
        self_update();
    };

    this.debug = new UsersDebug(this);

    /*
     * function used to display far resources near the background image
     */
    const position_boundaries = async (context, [x, y]) => {
        let map_media_id = await context.map_media_id;
        if (map_media_id === undefined) {
            return [x, y];
        }
        let map_media = await global.medias.load_media({local_id: map_media_id});
        if (map_media === undefined) {
            return [x, y];
        }
        let {width: w, height: h} = map_media;
        // padding
        const px = w / 10;
        const py = h / 10;
        x = Math.min(Math.max(-px, x), w + px);
        y = Math.min(Math.max(-py, y), h + py);
        return [x, y];
    };

    const get_object_translate = (transform) => {
        let {x, y} = get_translation(transform);
        return [x + 100, y + 100];
    };

    const set_object_translate = ([x, y]) => {
        return `translate(${x - 100},${y - 100})`;
    };

    const user_update_position = async (position, refresh) => {
        log.debug("Users.user_update_position in ", {position, refresh});
        if (space === null) {
            return;
        }
        for (let context of space.context) {
            if (context === null) {
                continue;
            }
            if (context.projection.project === null) {
                continue;
            }
            let {longitude: E1, latitude: N1} = position.coords;
            let [X1, Y1] = context.projection.project([E1, N1]);
            this.debug.trace_update(0, X1, Y1);
            // Kalman filter
            let state = context.projection.filter.feed({observation: [X1, Y1], time: performance.now()}); // position.timestamp
            if (state !== null) {
                [X1, Y1] = state.mean;
            }

            // do not use position_boundaries in google map mode
            if (!global.scene.map.is_gis) {
                [X1, Y1] = await position_boundaries(context, [X1, Y1]);
            }
            [E1, N1] = context.projection.project_invert([X1, Y1]);
            this.debug.trace_update(1, X1, Y1);

            // before associating device to user => coordinates are calculated from resource position on the map
            // when associating device to user => if position  change < MIN_DISTANCE_METERS, the user position won't be updated
            // and timestamp neither
            // => force timestamp update just after associating device to user (so after refresh)
            // time has to be updated before transform, because is nothing to be updated for transform => time not updated !?!
            if (refresh) {
                log.debug("Users.user_update_position update dataUser and dataLastGeolocTime");
                await context.object_update_path(
                    {
                        "object_data.attributes.dataUser": global.server.registrar.user.login
                    },
                    {
                        "object_data.attributes.dataLastGeolocTime": position.timestamp * 1000
                    }
                );
            }
            let position_to_update = false;

            log.debug("Users.user_update_position update dataUser and transform");
            await context.object_update_path(
                {
                    "object_data.attributes.dataUser": global.server.registrar.user.login
                },
                {
                    "object_data.attributes.transform": (old_transform) => {
                        if (old_transform === undefined) {
                            return old_transform;
                        }
                        let [X0, Y0] = get_object_translate(old_transform);
                        let [E0, N0] = context.projection.project_invert([X0, Y0]);
                        if (d3.geoDistanceMeters([E0, N0], [E1, N1]) < MIN_DISTANCE_METERS) {
                            log.debug("object_update_path distance < MIN_DISTANCE_METERS");
                            return old_transform;
                        }
                        position_to_update = true;
                        return set_object_translate([X1, Y1]);
                    }
                },
                {
                    "object_data.attributes.dataLastGeolocTime": (old_dataLastGeoloc) => {
                        if (old_dataLastGeoloc === undefined) {
                            return old_dataLastGeoloc;
                        }
                        // AGPOC-6677 : add time of last position in resource attributes so that it can be displayed in resource information
                        // respect above algorithm : update object only if position has changed (distance > MIN_DISTANCE_METERS)
                        if (!position_to_update) {
                            log.debug("object_update_path distance < MIN_DISTANCE_METERS");
                            return old_dataLastGeoloc;
                        }
                        log.debug("position to update");
                        return position.timestamp * 1000;
                    }
                }
            );

            // AGPOC-6677 : add time of last position in resource attributes so that it can be displayed in resource information
            // respect above algorithm : update object only if position has changed (distance > MIN_DISTANCE_METERS)
            /*if (position_to_update) {
                log.debug("Users.user_update_position update dataUser and dataLastGeolocTime");
                await context.object_update_path(
                    {
                        "object_data.attributes.dataUser": global.server.registrar.user.login
                    },
                    {
                        "object_data.attributes.dataLastGeolocTime": position.timestamp * 1000
                    }
                );
            }*/
        }
    };

    var sm = new StateMachine({
        name: "device_geolocation",
        shared_data: {},
        default_state: "disabled",
        states: {
            disabled: {
                in: () => {},
                out: () => {},
                transit: {
                    enable: {
                        state: "enabled",
                        handler: () => true
                    }
                },
                schedule: {}
            },
            enabled: {
                in: () => {
                    log.debug("Users.sm.enabled in");
                    // check android service here
                    global.geolocation.on_position_change(user_update_position);
                },
                out: () => {
                    log.debug("Users.sm.enabled out");
                    global.geolocation.off_position_change(user_update_position);
                },
                transit: {
                    disable: {
                        state: "disabled",
                        handler: () => true
                    }
                },
                schedule: {}
            }
        }
    });

    const object_on_creating = ({object_data}) => {
        log.debug("Users.object_on_creating ", object_data);
        if (global.geolocation.required) {
            return;
        }
        if (object_data.attributes?.dataType !== "resource") {
            return;
        }
        if (object_data.attributes?.dataUser !== global.server.registrar.user.login) {
            return;
        }
        log.debug("Users.object_on_creating sm -> enabled");
        sm.transition.enabled({});
    };

    const object_on_updating = ({object_data}, modifications) => {
        log.debug("Users.object_on_updating ", {object_data, modifications});
        if (global.geolocation.required) {
            return;
        }
        if (object_data.attributes?.dataType !== "resource") {
            return;
        }
        let modified = json_apply_modifications(object_data, "object_data", modifications);
        if (!modified) {
            return;
        }
        if (object_data.attributes?.dataUser !== global.server.registrar.user.login) {
            return;
        }
        log.debug("Users.object_on_updating sm -> enabled");
        sm.transition.enabled({});
    };

    this.position_refresh = async () => {
        log.debug("position_refresh in");
        var position = await global.geolocation.current_position();
        log.debug("position_refresh ", position);
        if (position === null) {
            return;
        }
        user_update_position(position, true);
    };

    this.get_agnet_user_name = () => {
        let name = global.internationalization.text("user.Unknown");
        if (global.configuration.user.first_name != undefined) {
            name = global.configuration.user.first_name;
            if (global.configuration.user.last_name != undefined) {
                name += " " + global.configuration.user.last_name;
            }
        } else {
            // first name undefined
            if (global.configuration.user.last_name != undefined) {
                name = global.configuration.user.last_name;
            }
        }
        return name;
    };

    const geolocation_state_update_capabilities = (geolocation_state) => {
        switch (geolocation_state) {
            case "enabled":
                global.server.registrar.set_capability(CAP_GEO | CAP_GEO_POS);
                break;
            case "errored":
                global.server.registrar.unset_capability(CAP_GEO_POS);
                break;
            case "disabled":
                global.server.registrar.unset_capability(CAP_GEO | CAP_GEO_POS);
                break;
        }
    };

    global.event_bus.subscribe("geolocation.state", ({state}) => {
        log.debug("Users -> on geolocation.state");
        geolocation_state_update_capabilities(state);
        self_update();
    });

    global.event_bus.subscribe("storage.space.changed", async ({old_space, new_space}) => {
        log.debug("Users -> on storage.space.changed");
        if (old_space !== null) {
            users.unset_all();
            style.rule_unset_all();
            old_space.off("objects", "creating", object_on_creating);
            old_space.off("objects", "updating", object_on_updating);
        }
        space = null;
        if (new_space !== null) {
            space = new_space;
            new_space.on("objects", "creating", object_on_creating);
            new_space.on("objects", "updating", object_on_updating);
            await this.sync();
            for (let context of new_space.context) {
                if (context === null) {
                    continue;
                }
                let linked_object = await context
                    .object_path({
                        key: "object_data.attributes.dataUser"
                    })
                    .equals(global.server.registrar.user.login)
                    .first();
                if (linked_object === undefined) {
                    continue;
                }
                sm.transition.enabled({});
            }
        }
    });

    global.event_bus.subscribe("storage.shared", () => {
        log.debug("Users -> on storage.shared");
        if (space === null) {
            return;
        }
        this.sync();
    });

    global.event_bus.subscribe("network.online", () => {
        log.debug("Users -> on network.online before Users.sync");
        if (space === null) {
            return;
        }
        this.sync();
    });

    global.event_bus.subscribe("subscribe.connected", () => {
        log.debug("Users -> on subscribe.connected");
        if (space === null) {
            return;
        }
        this.sync();
    });

    global.server.subscribe.on("user", ({status, login, name, capabilities}) => {
        log.debug("Users -> on user ", {status, login, name, capabilities});
        switch (status) {
            case "connect":
            case "update":
                user_update(login, name, capabilities);
                break;
            case "disconnect":
                user_remove(login);
                break;
        }
    });

    this.init = () => {
        log.debug("init in");
        geolocation_state_update_capabilities(global.geolocation.state);
        self_update();
    };
};

global.app.bootstrap.register_module({
    name: "users",
    deps: ["geolocation"],
    init: () => {
        global.users = new Users();
        global.users.init();
    }
});

export default Users;
